import { registerLocaleData } from '@angular/common';
import localeDutch from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeFinnish from '@angular/common/locales/fi';
import localeNorwegian from '@angular/common/locales/nb';
import localeNatherland from '@angular/common/locales/nl';
import { Injectable } from '@angular/core';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { ThemesService } from 'projects/Autofacets-Core/src/app/services/themes.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { CultureCodes } from '../../../../Autofacets-Core/src/app/utils/enums';
import { SettingService } from '../business-services/setting.service';
import { ClientAppToken, EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { environment } from 'projects/Widget/src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CultureLocaleService {

  constructor(
    private settingService: SettingService,
    private secureStorage: SecureStorage,
    private themservice: ThemesService,
    private currentLanguage: CurrentLanguage,
    private globalSetting: GlobalSetting
  ) { }

  private _locale: string;
  private cultureCode: string;
  public currencyCode: string;
  globalizationValues: any;

  async initialise() {
    this.cultureCode = Constant.defaultISOCultureCode;
    EnvSetting.BRAND_API_URL = `${environment.WIDGET_API_URI}Brands/GetBrandLogo`;
    if (ClientAppToken()) {
      await this.settingService.GetSettings().then(async (res) => {
        await this.LoadConfig(res.responseObject);
        this.secureStorage.removeKey('feature');
        await this.settingService.getFeatures().then((res) => {
          if (res.responseObject.errorCount === 0) {
            this.settingService.features = res.responseObject.result;
            this.currentLanguage.featureList.next(this.settingService.features);
            this.secureStorage.setKeyData('feature', this.settingService.features);
          }
        });
      });
    }
    else {
      await this.settingService.GetGenericSettings().then(async (res) => {
        await this.LoadConfig(res.responseObject);
        await this.settingService.getGenericFeatures().then((res) => {
          if (res.responseObject.errorCount === 0) {
            this.settingService.features = res.responseObject.result;
            this.currentLanguage.featureList.next(this.settingService.features);
            this.secureStorage.setKeyData('feature', this.settingService.features);
          }
        });
      });
    }
  }

  private async LoadConfig(response: any) {
    if (response) {
      this.globalizationValues = response;
      if (this.globalizationValues && this.globalizationValues.length > 0) {
        this.globalSetting.MapAppSetting(this.globalizationValues);
        const LicencePlateClass = this.getSettingValue('LicencePlateClass');
        this.secureStorage.setKeyData('LicencePlateClass', LicencePlateClass);

        const TermsConditionData = this.getSettingValue('TermsCondiData');
        this.secureStorage.setKeyData('TermsConditionData', TermsConditionData);

        const cultureCodeValue = this.getSettingValue('CultureCode');
        if (cultureCodeValue) {
          this.cultureCode = cultureCodeValue;
          this.currentLanguage.cultureCodeSubject.next(this.cultureCode);
          this.secureStorage.setKeyData('CultureCode', this.cultureCode);
        }
        const logo = this.getSettingValue('LogoUrlLink');
        this.secureStorage.setKeyData('LogoUrlLink', logo);

        const timeZoneValue = this.getSettingValue('TimeZoneStandardName');
        if (timeZoneValue) {
          this.currentLanguage.timeZoneStandradName.next(timeZoneValue);
          this.secureStorage.setKeyData('TimeZoneStandradName', timeZoneValue);
        }
        const tenant = this.getSettingValue('Tenant');
        localStorage.setItem('Theme', tenant);
        if (tenant) {
          this.themservice.themeInitializer();
        }
        this.registerCulture(this.cultureCode);
        this.currencyCode = this.settingService.getCurrencyCode(this.cultureCode);
      }
    }
  }
  getSettingValue(key: string) {
    return this.globalizationValues.find(x => x.property === key)?.value;
  }

  getLocale(): string {
    return this._locale || 'en';
  }

  getLocaleEN() {
    this._locale = 'en'
    registerLocaleData(localeEn, 'en');
  }

  registerCulture(culture: string) {
    switch (culture) {
      case CultureCodes.NB_NO: {
        this._locale = 'no'
        registerLocaleData(localeNorwegian, 'no');
        break;
      }
      case CultureCodes.EN_US: {
        this.getLocaleEN()
        break;
      }
      case CultureCodes.FI_FI: {
        this._locale = 'fi'
        registerLocaleData(localeFinnish, 'fi');
        break;
      }
      case CultureCodes.NL_NL: {
        this._locale = 'nl'
        registerLocaleData(localeNatherland, 'nl');
        break;
      }
      case CultureCodes.DE_DE: {
        this._locale = 'de'
        registerLocaleData(localeDutch, 'de');
        break;
      }
      default:
        this.getLocaleEN();
    }
  }
}
